export function encodeBmp(imageData: ImageData) {
  const { width, height, data } = imageData;
  const rowSize = Math.ceil((width * 3) / 4) * 4;
  const pixelSize = rowSize * height;
  const fileSize = 54 + pixelSize;
  const buffer = new ArrayBuffer(fileSize);
  const view = new DataView(buffer);
  const bytes = new Uint8Array(buffer);

  view.setUint16(0, 0x4d42, true);
  view.setUint32(2, fileSize, true);
  view.setUint32(10, 54, true);
  view.setUint32(14, 40, true);
  view.setInt32(18, width, true);
  view.setInt32(22, height, true);
  view.setUint16(26, 1, true);
  view.setUint16(28, 24, true);
  view.setUint32(34, pixelSize, true);
  view.setInt32(38, 2835, true);
  view.setInt32(42, 2835, true);

  let target = 54;
  for (let y = height - 1; y >= 0; y -= 1) {
    const sourceRow = y * width * 4;
    for (let x = 0; x < width; x += 1) {
      const source = sourceRow + x * 4;
      bytes[target++] = data[source + 2];
      bytes[target++] = data[source + 1];
      bytes[target++] = data[source];
    }
    target += rowSize - width * 3;
  }

  return new Blob([buffer], { type: "image/bmp" });
}

export function encodeTiff(imageData: ImageData) {
  const { width, height, data } = imageData;
  const entryCount = 12;
  const ifdOffset = 8;
  const ifdSize = 2 + entryCount * 12 + 4;
  const bitsOffset = ifdOffset + ifdSize;
  const xResolutionOffset = bitsOffset + 6;
  const yResolutionOffset = xResolutionOffset + 8;
  const pixelOffset = yResolutionOffset + 8;
  const pixelSize = width * height * 3;
  const buffer = new ArrayBuffer(pixelOffset + pixelSize);
  const view = new DataView(buffer);
  const bytes = new Uint8Array(buffer);

  bytes[0] = 0x49;
  bytes[1] = 0x49;
  view.setUint16(2, 42, true);
  view.setUint32(4, ifdOffset, true);
  view.setUint16(ifdOffset, entryCount, true);

  let entry = ifdOffset + 2;
  const writeEntry = (tag: number, type: number, count: number, value: number) => {
    view.setUint16(entry, tag, true);
    view.setUint16(entry + 2, type, true);
    view.setUint32(entry + 4, count, true);
    view.setUint32(entry + 8, value, true);
    entry += 12;
  };

  writeEntry(256, 4, 1, width);
  writeEntry(257, 4, 1, height);
  writeEntry(258, 3, 3, bitsOffset);
  writeEntry(259, 3, 1, 1);
  writeEntry(262, 3, 1, 2);
  writeEntry(273, 4, 1, pixelOffset);
  writeEntry(277, 3, 1, 3);
  writeEntry(278, 4, 1, height);
  writeEntry(279, 4, 1, pixelSize);
  writeEntry(282, 5, 1, xResolutionOffset);
  writeEntry(283, 5, 1, yResolutionOffset);
  writeEntry(296, 3, 1, 2);
  view.setUint32(entry, 0, true);

  view.setUint16(bitsOffset, 8, true);
  view.setUint16(bitsOffset + 2, 8, true);
  view.setUint16(bitsOffset + 4, 8, true);
  writeRational(view, xResolutionOffset, 72, 1);
  writeRational(view, yResolutionOffset, 72, 1);

  let target = pixelOffset;
  for (let source = 0; source < data.length; source += 4) {
    bytes[target++] = data[source];
    bytes[target++] = data[source + 1];
    bytes[target++] = data[source + 2];
  }

  return new Blob([buffer], { type: "image/tiff" });
}

function writeRational(view: DataView, offset: number, numerator: number, denominator: number) {
  view.setUint32(offset, numerator, true);
  view.setUint32(offset + 4, denominator, true);
}
